import { render } from "./InfiniteLoadingFixed.vue?vue&type=template&id=53290893"
import script from "./InfiniteLoadingFixed.vue?vue&type=script&lang=js"
export * from "./InfiniteLoadingFixed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__